<script>
import { vitalsMetaFields as metaFields } from "./metaFields";
import { Validator, } from "@/plugins/validator";
export default {
    name: "AddVitalsForm",

    data() {

        return {
            errors: []
        };
    },

    props: {

        vital: Object,
        showModal: Boolean,
        vitalsParameters: Array,
    },

    computed: {

      minMaxVital() {
            if(!this.vital.parameterID) return new Object;

            const matchedVitals = this.vitalsParameters.filter(vt => vt.parameterID == this.vital.parameterID);

            return matchedVitals.length ? matchedVitals[0] : new Object;
      },
    },

    watch: {

        "vital.parameterID"() {
            const matchedVitals = this.vitalsParameters.filter(vt => vt.parameterID == this.vital.parameterID);

            this.vital.parameter = matchedVitals.length ? matchedVitals[0].parameter : ``; 
        },
    },

    methods: {

      saveData() {

        (new Validator(this.vital, metaFields).validate()).then(() => {
            this.$root.loading = true;
            this.$http.post(`NursingFile/NursingFileVitals`, this.vital).then(response => {
                this.$emit('refresh');
                this.$root.loading = false;
                this.$emit('closeModal');
                window.Swal.fire({ type: `success`, text: response.data});
            }).catch(() => { this.$root.loading = false; });
        }).catch(errors => {
            this.errors = errors;
        }); 
      },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-base">Add Vital</h5>
      </template>
      <template v-slot:modal-body>
        <div class="flex md:flex-row sm:flex-col -m-2">
            <div class="md:w-1/3 sm:w-full p-tiny">
                <label for="grid-select-vital" class="label-control">Vital : 
                    <span class="text-xs">{{vital.parameter}}</span></label>
                <tail-select>
                    <template v-slot:field>
                        <select v-model.number="vital.parameterID" 
                            id="grid-select-vital" class="input-control input-sm text-sm">
                            <option value="">select parameter</option>
                            <option v-for="(vitalsParameter, idx) in vitalsParameters" 
                                :key="idx" :value="vitalsParameter.parameterID">
                                    {{ vitalsParameter.parameter }}</option>
                        </select>
                      </template>
                </tail-select>
            </div>
            <div class="md:w-1/5 sm:w-full p-tiny">
                <label for="grid-min-value" class="label-control">Min: Value</label>
                <input type="text" :value="minMaxVital.minValue" 
                    id="grid-min-value" class="input-control input-sm text-sm disabled" disabled>
            </div>
            <div class="md:w-1/5 sm:w-full p-tiny">
                <label for="grid-max-value" class="label-control">Max: Value</label>
                <input type="text" :value="minMaxVital.maxValue" 
                    id="grid-max-value" class="input-control input-sm text-sm disabled" disabled>
            </div>
            <div class="md:w-1/6 sm:w-full p-tiny">
                <label for="grid-input-value" class="label-control">Value</label>
                <input type="text" v-model.trim="vital.value" 
                    id="grid-input-value" class="input-control input-sm text-sm">
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-danger btn-sm text-xs rounded mr-4" 
            @click="$emit(`closeModal`)"><i class="fa fa-times"></i> Cancel</button>
        <button class="btn-primary btn-sm text-xs rounded" 
            @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
      </template>
    </tail-modal>
</template>